import { Typography } from '@mui/material';
import { map } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DataGrid, DataGridColumnDefinition } from 'components';
import { DefaultPaymentTypeCode } from 'enums';
import { useQueryColumns } from 'hooks/use-query-columns.hook';
import { TranslationNamespace } from 'i18n';
import { MonitoringDataItem, RangeMonitoringDataRow } from 'types';
import { orderMonitoringUtils } from 'utils';

type Props = {
  rangeLabel: string;
  rangeData: RangeMonitoringDataRow<MonitoringDataItem>;
  availablePaymentTypes?: DefaultPaymentTypeCode[];
  className?: string;
};

export const OrdersMonitoringPayinRange: React.FC<Props> = ({
  rangeLabel,
  rangeData,
  availablePaymentTypes = [],
  className,
}) => {
  const { visibleColumns } = useQueryColumns();
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders_monitoring',
  });

  const title = useMemo(
    () => `${t('amount_range')}: ${rangeLabel}`,
    [rangeLabel, t],
  );

  const columns: DataGridColumnDefinition[] = useMemo(
    () =>
      map(availablePaymentTypes, (paymentType) => ({
        header: orderMonitoringUtils.getPaymentTypeHeader(paymentType),
        valueGetter: (item) => {
          const value = item[paymentType];
          return orderMonitoringUtils.getAmountRangeCell(value);
        },
        hidden: visibleColumns?.[paymentType] === false,
        valueClassName: 'tw-bg-gradient-to-l !tw-p-0 !tw-font-bold',
      })),
    [availablePaymentTypes, visibleColumns],
  );

  return (
    <div className={className}>
      <Typography variant="h4">{title}</Typography>
      <div className="tw-my-2">
        <DataGrid
          tableStyle={{ tableLayout: 'fixed' }}
          columns={columns}
          data={[rangeData]}
        />
      </div>
    </div>
  );
};
